<template>
    <div class="content">
        <div class="content-head">
            <div class="content-head-title">搜索</div>
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="项目类型">
                    <el-select v-model="params.Credit_CommercialBill_Type" placeholder="请选择项目类型" class="el-select-medium">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option v-for="item in Credit_CommercialBill_Typeopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="当前状态">
                    <el-button type="primary" plain @click="getChangeControlstatus()">选择状态</el-button>
                </el-form-item>
                <el-form-item label="经办人">
                    <el-input v-model="params.officeman" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="客户名称">
                    <el-input v-model="params.Credit_CommercialBill_CustomerName" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item label="汇票编号">
                    <el-input v-model="params.Credit_CommercialBill_SN" placeholder="" clearable class="el-select-medium"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getCreditCommercialBills(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh()" icon="el-icon-refresh" :loading="loadingBtn">重置</el-button>
                </el-form-item>
            </el-form>
            <div class="multiple-status-checked" v-if="this.params.StateList && this.params.StateList.length > 0">
                <span class="multiple-status-checked-lable">所选状态：</span>
                <span class="multiple-status-checked-value" v-for="(item, index) in multiple_status_list" :key="index">{{ item.Name }}</span>
            </div>
        </div>
        <div class="content-table">
            <div class="content-table-title">
                项目列表
                <span>
                    <el-button type="primary" @click="getAddCommercialBillCheck()" icon="el-icon-plus">新增</el-button>

                    <el-dropdown trigger="click" style="margin-left: 10px; margin-right: 10px">
                        <el-button>
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getCreditCommercialBillExport()">导出查询信息</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <el-table :data="tableData" :height="maxheight" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column prop="Credit_CommercialBill_ID" label="ID" align="center" width="80" fixed="left"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_SN" label="汇票编号" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_StateName" label="状态" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_ProjectMoney" label="金额" align="center" width="120">
                    <template slot-scope="scope">
                        {{ scope.row.Credit_CommercialBill_ProjectMoney | thousandSeparator }}
                    </template>
                </el-table-column>
                <el-table-column prop="Credit_CommercialBill_PaymentID" label="混合付款ID" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_Balance" label="分配金额" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_IssueDate" label="出票日期" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_DueDate" label="到期日期" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_Acceptor" label="承兑人" show-overflow-tooltip align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_FormerEndorser" label="前手背书人" show-overflow-tooltip align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_TypeName" label="类型" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_OfficeName" label="分支机构" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_LargeRegionName" label="大区" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_CustomerName" show-overflow-tooltip label="客户名称" align="center" width="150"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_CustomerUniformCode" label="客户统一编号" align="center" width="120"></el-table-column>
                <el-table-column prop="Credit_CommercialBill_AgentName" label="业务员" show-overflow-tooltip align="center" width="120"></el-table-column>
                <el-table-column prop="OwnerEmail" label="操作" align="center" width="80" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="getOpenDetails(scope.row)">查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <el-dialog title="状态选择" :visible.sync="isStatusdialog" width="50%" :before-close="handleClose" :close-on-click-modal="false" center>
            <div v-for="(item, index) in StateListopt" :key="index" v-loading="isStatusLoading">
                <span class="multiple-title">{{ item.Name }}</span>
                <div>
                    <el-checkbox :isIndeterminate="item.isIndeterminate" v-model="item.checkAll" @change="handleCheckAllChange($event, item)">全选</el-checkbox>
                    <div style="margin: 15px 0"></div>
                    <el-checkbox-group v-model="item.checkFlag" @change="handleCheckedCitiesChange($event, item)">
                        <el-checkbox v-for="city in item.StateList" :label="city.ID" :key="city.ID">{{ city.Name }}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleMultipleSave()">保存勾选状态</el-button>
            </span>
        </el-dialog>
        <acceptance-add :isAcceptanceAdd="isAcceptanceAdd" :isCheckUpload="isCheckUpload" :StateList="StateList" @onClose="onClose"></acceptance-add>
        <acceptance-detail :isDetail="isDetail" :id="id" @onDetailClose="onDetailClose"></acceptance-detail>
    </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue';
import acceptanceAdd from './components/acceptanceAdd.vue';
import acceptanceDetail from './components/acceptanceDetail.vue';
import { downloadFile, toLowerCaseKeys } from '@/utils/utils.js';
import { myMixin } from '@/utils/mixin.js';
import { cloneDeep } from 'lodash';
export default {
    name: 'commercialAcceptance',
    mixins: [myMixin],
    components: {
        Pagination,
        acceptanceAdd,
        acceptanceDetail
    },
    data() {
        return {
            isDetail: false,
            loadingBtn: false,
            isStatusLoading: false,
            isStatusdialog: false,
            isAcceptanceAdd: false,
            isCheckUpload: false,
            id: '',
            params: {
                Credit_CommercialBill_Type: 0,
                officeman: '',
                Credit_CommercialBill_CustomerName: '',
                Credit_CommercialBill_SN: '',
                StateList: ''
            },
            tableData: [],
            StateListopt: [],
            StateList: [],
            multiple_status_list: [],
            Credit_CommercialBill_Typeopt: [
                { label: '纸质', value: 1 },
                { label: '电子', value: 2 }
            ]
        };
    },
    mounted() {
        this.getCreditCommercialBills();
        this.getCreditStateList();
    },
    methods: {
        onRefresh() {
            this.params = {
                Credit_CommercialBill_Type: 0,
                officeman: '',
                Credit_CommercialBill_CustomerName: '',
                Credit_CommercialBill_SN: '',
                StateList: ''
            };
            this.StateListopt = [];
            this.multiple_status_list = [];
            this.getCreditCommercialBills(true);
        },
        /*
 查询列表
 */
        getCreditCommercialBills(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi
                .getCreditCommercialBills(this.filteropt())
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;
                    } else {
                        this.tableData = [];
                        this.paginationOptions.total = 0;
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = cloneDeep(this.params);
            return { json: JSON.stringify(toLowerCaseKeys(params)), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        getCreditCommercialBillExport() {
            this.$newsApi.getCreditCommercialBillExport(this.filteropt()).then((res) => {
                if (res.data.Resultcode == 0) {
                    downloadFile(res.data.data, res.data.Resultinfo);
                }
            });
        },
        getAddCommercialBillCheck() {
            this.$newsApi.getAddCommercialBillCheck().then((res) => {
                if (res.data.Resultcode === 0) {
                    if (res.data.Resultinfo == 'true') {
                        this.isAcceptanceAdd = true;
                    }
                    if (res.data.data == 'true') {
                        this.isCheckUpload = true;
                    }
                }
            });
        },
        onClose(flag) {
            console.log(flag, '=========');
            if (flag) {
                this.onRefresh();
            }
            this.isAcceptanceAdd = false;
        },

        getCreditStateList() {
            this.isStatusLoading = true;
            this.$newsApi
                .getCreditStateList({ type: 8 })
                .then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.StateListopt = res.data.data;
                        this.StateListopt.forEach((item) => {
                            this.$set(item, 'isIndeterminate', true);
                            this.$set(item, 'checkAll', false);
                            this.$set(item, 'checkFlag', []);
                        });
                        this.StateList = this.StateListopt[0].StateList;
                    }
                })
                .finally(() => (this.isStatusLoading = false));
        },
        handleCheckAllChange(val, row) {
            if (val) {
                row.checkFlag = row.StateList.map((item) => {
                    return item.ID;
                });
                return;
            }
            row.checkFlag = [];
        },
        handleCheckedCitiesChange(val, row) {
            let checkedCount = val.length;
            console.log(val, row, checkedCount);
            row.checkAll = row.StateList.length === row.checkFlag.length;
            row.isIndeterminate = checkedCount > 0 && checkedCount < row.checkFlag.length;
        },
        handleMultipleSave() {
            const result = [];
            this.StateListopt.forEach((item) => {
                Array.prototype.push.apply(
                    result,
                    item.StateList.filter((idm) => item.checkFlag.includes(idm.ID))
                );
            });
            this.params.StateList = result.map((item) => item.ID).join(',');
            this.multiple_status_list = result;
            //   this.params.StateList = this.StateListopt.flatMap(item => item.checkFlag).join(',')
            this.isStatusdialog = false;
            console.log(this.params, '===================');
        },
        getChangeControlstatus() {
            this.isStatusdialog = true;
        },
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getCreditCommercialBills();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getCreditCommercialBills();
        },
        handleClose() {
            this.isStatusdialog = false;
        },
        getOpenDetails(row) {
            this.id = row.Credit_CommercialBill_ID;
            this.isDetail = true;
        },
        onDetailClose() {
            this.onRefresh();
            this.isDetail = false;
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/.Collect .el-descriptions-item__cell {
    text-align: center !important;
}
/deep/.Collect.custom-label {
    text-align: center !important;
    width: 170px;
}
.multiple-title {
    font-size: 15px;
    font-weight: 522;
    color: #222222;
    line-height: 50px;
}
.multiple-status-checked {
    font-size: 13px;
}
.multiple-status-checked-value {
    color: #000000;
    margin-right: 10px;
}
</style>